<template>
  <div class="yunxiao student-details" data-test="base-student-details" ref="main">
    <student-infos :studentInfos="studentInfos" :studentSuspendDetail="studentSuspendDetail"/>
    <div class="main-nav" ref="tabBox" :class="{ white: activeTab == 2 }">
      <van-tabs v-model="activeTab" :line-width="22" :line-height="3" :ellipsis="false" swipeable>
        <van-tab v-if="app.permission.op('find_student_card || find_student_card_detail')" title="学员卡包" name="0">
          <div class="check-box">
            <!-- <van-checkbox v-model="isdeactivated" icon-size="var(--fs-md)" @change="showFeeWarnFun">显示不再费用预警({{studentNotFeeWarnCount}})</van-checkbox> -->
          </div>
          <van-pull-refresh class="vxlist" v-model="isLoading" @refresh="getStudentCard">
            <shangkeCardComp :list="studentCardList" />
          </van-pull-refresh>
        </van-tab>
        <van-tab v-if="app.permission.op('query_student_study')" :title="`就读课程`" name="1">
          <div class="check-box" >
            <!-- <van-checkbox v-model="showStopAttendCourse" icon-size="var(--fs-md)" >显示不再上课({{noLongerCourseCount}})</van-checkbox> -->
          </div>
          <vx-list
            class="vxlist"
            enable
            ref="sRecordVxList"
            :params="attendCourseParams"
            :api="$api.findStudentAttendCourse"
            :pageSize="10"
            @load="studentAttendCourseLoad"
          >
            <jiuduRecordComp
              :list="schoolRecordList"
              :studentId="stuId"
              :studentName="studentInfos.name"
            />
          </vx-list>
        </van-tab>
        <van-tab v-if="app.permission.op('find_student_roll_call')" title="点名记录" name="2">
          <div @touchstart.stop  @touchend.stop @touchmove.stop id="kechengTag" v-if="courseTag.length">
            <van-tabs
              :swipe-threshold="2"
              type="card" 
              color="rgba(var(--c1-rgb), 0.12)"
              swipeable title-active-color="var(--c1)" 
              title-inactive-color="var(--g7)"  
              @click="changeCourseTag"
              ref="courseTab">
              <van-tab 
                title-class="course-tag" 
                v-for="item in courseTag" 
                :key="item.id" 
                :title="item.curriculumName"></van-tab>
            </van-tabs>
          </div>
          <vx-list
            class="vxlist"
            enable
            ref="rollCallVxList"
            :params="commonParams2"
            :api="$api.findStudentRollCall"
            :pageSize="10"
            @load="list => (rollCallList = list)"
            @refresh="onRollCallListRefresh"
          >
            <div class="more-detail-infos">
              <span>
                点名：
                <span>出勤{{ signCostData.attendanceCount }}</span>
                <span>·迟到{{ signCostData.lateCount }}</span>
                <span>·请假{{ signCostData.askForLeaveCount }}</span>
                <span>·未到{{ signCostData.notArrivedCount }}</span>
                <span>（已补{{ signCostData.remediedCount }}）</span>
              </span>
              <span
                >上课:<span class="total-hour-cost">{{
                  signCostData.courseAmount || 0
                }}</span>{{lessonUnit}}</span
              >
            </div>
            <callTheRoll class="call-the-roll" :list="rollCallList" />
          </vx-list>
        </van-tab>
        <van-tab title="意向课程" name="5">
          <vx-list
            class="vxlist"
            enable
            ref="clueVxList"
            :params="commonParams"
            :api="$api.clueAllPage"
            :pageSize="10"
            @load="list => (cluesList = list)"
          >
            <intentionClues :list="cluesList" :studentId="stuId" />
          </vx-list>
        </van-tab>
        <van-tab v-if="app.permission.op('query_student_communicate')" :title="`沟通记录`" name="3">
          <vx-list
            class="vxlist"
            enable
            ref="communicateVxList"
            :params="commonParams"
            :api="$api.getCommunicateListByStudentId"
            :pageSize="10"
            @load="list => (communicateList = list)"
          >
            <intention-communicate
              :showStudent="false"
              :showObject="true"
              :list="communicateList"
              :fromPage="'student'"
              @add="gotoAddCommunicate"
            />
          </vx-list>
        </van-tab>
        <van-tab :title="`试听记录`" name="4" v-if="app.permission.op('query_audition')">
          <vx-list
            class="vxlist"
            enable
            ref="audtVxList"
            :params="auditionParams"
            :api="$api.auditionPage"
            :pageSize="10"
            @load="list => (auditionList = list)"
          >
            <intention-audition :list="auditionList" />
          </vx-list>
        </van-tab>
        <van-tab :title="`课堂点评`" name="6" v-if="app.permission.op('query_student_course_comment')">
          <vx-list
            class="vxlist"
            enable
            ref="courseCommentVxList"
            :params="commonParams"
            :api="$api.courseCommentPage"
            :pageSize="10"
            @load="list => (courseCommentList = list)"
          >
            <course-comment-comp :list="courseCommentList" />
          </vx-list>
        </van-tab>
        <van-tab :title="`成长记录`" name="7" v-if="app.permission.op('query_student_archives_grow_up')">
          <vx-list
            class="vxlist"
            enable
            ref="growUpRecordVxList"
            :params="commonParams"
            :api="$api.archivesGrowUpPage"
            :pageSize="10"
            @load="list => (growupList = list)"
          >
            <growup-record-comp :list="growupList" />
          </vx-list>
        </van-tab>
        <van-tab :title="`测评报告`" name="8" v-if="app.permission.op('query_student_evaluation_stage_test')">
          <vx-list
            class="vxlist"
            enable
            ref="evaluateReportVxList"
            :params="commonParams"
            :api="$api.stageTestUnionQuery"
            :pageSize="10"
            @load="list => (evaluateReportList = list)"
          >
            <evaluate-report-comp :list="evaluateReportList" />
          </vx-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import studentInfos from './children/student-infos.vue';
import shangkeCardComp from './children/shangke-card-comp.vue';
import jiuduRecordComp from './children/jiudu-record-comp.vue';
import callTheRoll from '@x3/vue/comp/call-the-roll.vue';
import intentionAudition from './children/intention-audition.vue';
import intentionCommunicate from './children/intention-communicate.vue';
import intentionClues from './children/intention-clues.vue';
import courseCommentComp from './children/course-comment-comp.vue';
import growupRecordComp from './children/growup-record-comp.vue';
import evaluateReportComp from './children/evaluate-report-comp.vue';
import tabsFix from '@teacher/mixins/tabs-fix.js';

export default {
  name: 'StudentDetails',
  mixins: [tabsFix],
  components: {
    studentInfos,
    intentionAudition,
    intentionCommunicate,
    shangkeCardComp,
    jiuduRecordComp,
    callTheRoll,
    intentionClues,
    courseCommentComp,
    growupRecordComp,
    evaluateReportComp,
  },
  data() {
    let stuid = this.$vxRoute.query.id;
    return {
      pageTitle: '学员详情',
      stuId: this.$vxRoute.query.id,
      studentInfos: {
        photo: '',
        name: '',
        isHistory: '',
        status: '',
      },
      studentSuspendDetail: {
        id: '',
        recoveryCourseDate: '',
        suspendCourseDate: ''
      },
      activeTab: '-1',
      loading: false,
      studentCardList: [],
      // studentNotFeeWarnCount: 0,
      schoolRecordList: [],
      rollCallList: [],
      auditionList: [],
      communicateList: [],
      cluesList: [],
      signCostData: {
        absentFromWork: 0,
        attendanceCount: 0,
        costCourseAmount: 0,
        totalCount: 0,
      },
      commonParams: {
        studentId: stuid,
      },
      auditionParams: {
        studentIds: [stuid],
      },
      // classCardParams: {
      //   studentId: stuid,
      //   // feeWarn: 1
      // },
      // isdeactivated: false,
      showStopAttendCourse: false,
      noLongerCourseCount: 0,
      courseTag: [],
      courseTagCurriculumIds: [],
      isLoading: false,
      courseCommentList: [],
      growupList: [],
      evaluateReportList: []
    };
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
    attendCourseParams () {
      let params = {...this.commonParams};
      // if (!this.showStopAttendCourse) params.status = 1;
      return params
    },
    commonParams2 () {
      return {
        ...this.commonParams,
        curriculumIds: this.courseTagCurriculumIds
      }
    }
  },
  methods: {
    changeCourseTag(index){
      if (index === 0) {
        this.courseTagCurriculumIds = []
      } else {
        this.courseTagCurriculumIds = [this.courseTag[index].id];
      }
      this.__isGeted22 = false;
      this.getSignCostData();
    },
    // 获取点名的课程tag
    async curriculumListByRollCall(){
      const res = await this.$api.curriculumListByRollCall({
        campusIds: [],
        studentId: +this.stuId,
        page: {
          pageNum: 1,
          pageSize: 999
        }
      });
      this.courseTag = res.data;
      this.courseTag.unshift({
        curriculumName: '全部课程',
        id: 'all',
      })
      
    },
    // 获取学员信息
    async getStudent() {
      let id = this.stuId;
      if (!id) {
        return false;
      }
      this.showLoading();

      let getStudentQuery = this.$api.getContainFace({
        id: id,
        companyId: app.teacher.user.companyId,
      });
      let getStudentSuspendDetail = this.$api.getStudentSuspendDetail({
        studentId: this.stuId
      });

      try {
        let res = await Promise.all([getStudentQuery, getStudentSuspendDetail]);
        this.$toast.clear();
        this.studentInfos = res[0].data;
        let susDetail = res[1].data ? res[1].data : {
          recoveryCourseDate: '',
          suspendCourseDate: ''
        };
        this.studentSuspendDetail = Object.assign(this.studentSuspendDetail, susDetail);
      } catch {
        this.$toast.clear();
      }
    },
    // 获取学员汇总点名数据
    async getSignCostData() {
      if (!this.__isGeted22) {
        let ret = await this.$api.findCourseRollCallCount({
          studentId: this.stuId,
          curriculumIds: this.courseTagCurriculumIds,
        });
        this.signCostData = ret.data;
        this.__isGeted22 = true
      }
    },
    async getStudentCard() {
      let ret = await this.$api.findStudentCard({
        studentId: this.stuId,
      })
      this.isLoading = false;
      this.studentCardList = ret.data;
    },
    async getData() {
      let nv = this.activeTab;
      if (nv == 0) {
        // this.isdeactivated = false;
        // this.$set(this.classCardParams, 'feeWarn', 1);
        this.getStudentCard();
      }
      if (nv == 2) {
        this.getSignCostData();
      }
    },
    //添加沟通记录
    gotoAddCommunicate() {
      this.$router.push(`/addStudentCommunication?id=${this.stuId}`);
    },
    // 意向刷新
    refreshCluesList() {
      this.$refs['clueVxList'] && this.$refs['clueVxList'].hightReFresh();
    },
    studentAttendCourseLoad (list, res) {
      let cclist = res.data.studentAttendCourseList || [];
      if (res.page && res.page.pageNum == 1) {
        this.schoolRecordList = cclist || []
      } else {
        Array.isArray(cclist) && this.schoolRecordList.push(...cclist);
      }
      this.noLongerCourseCount = res.data.noLongerCourseCount;
      // this.noLongerCourseCount = res.data && res.data.noLongerCourseCount;
      // this.schoolRecordList = res.data && res.data.studentAttendCourseList;
    },
    onRollCallListRefresh() {
      this.__isGeted22 = false;
      this.getSignCostData();
    },
    // showFeeWarnFun(e) {
    //   if (e) {
    //     this.$delete(this.classCardParams, 'feeWarn');
    //   } else {
    //     this.$set(this.classCardParams, 'feeWarn', 1);
    //   }
    // },
    monitorRefresh() { // 监听刷新
      // 卡包刷新
      this.$onBus('refresh-student-school-card-list', ()=> {
        if (app.permission.op('find_student_card || find_student_card_detail')) {
          this.getStudentCard();
        }
      });

      // 就读课程刷新
      this.$onBus('refresh-student-school-record-list', ()=> {
        this.$refs['sRecordVxList'] && this.$refs['sRecordVxList'].hightReFresh();
      });

      // 点名记录刷新
      // this.$onBus('refresh-rollcall-list', ()=> {
      //   this.$refs['rollCallVxList'] && this.$refs['rollCallVxList'].hightReFresh();
      // })

      // 意向课程刷新
      this.$onBus('resume-clues-success', this.refreshCluesList);
      this.$onBus('delete-clues-success', this.refreshCluesList);
      this.$onBus('refresh-student-clues-record-list', this.refreshCluesList);

      // 沟通记录刷新
      this.$onBus('refresh-student-communicate-list', ()=> {
        this.$refs['communicateVxList'] && this.$refs['communicateVxList'].hightReFresh();
      });

      // 点评刷新
      this.$onBus('refresh-student-course-comment-list', ()=> {
        this.$refs['courseCommentVxList'] && this.$refs['courseCommentVxList'].hightReFresh();
      });

      // 成长记录刷新
      this.$onBus('refresh-student-growup-record-list', ()=> {
        this.$refs['growUpRecordVxList'] && this.$refs['growUpRecordVxList'].hightReFresh();
      });

      // 测评报告刷新
      this.$onBus('refresh-student-evaluate-report-list', ()=> {
        this.$refs['evaluateReportVxList'] && this.$refs['evaluateReportVxList'].hightReFresh();
      });
    }
  },
  created() {
    if (app.permission.op('find_student_card_detail')) {
      this.activeTab = '0';
    } else if (app.permission.op('query_student_study')) {
      this.activeTab = '1';
    } else if (app.permission.op('find_student_roll_call')) {
      this.activeTab = '2';
    } else if (app.permission.op('query_student_communicate')) {
      this.activeTab = '3';
    } else if (app.permission.op('query_audition')) {
      this.activeTab = '4';
    } else if (app.permission.op('query_student_course_comment')) {
      this.activeTab = '6';
    } else if (app.permission.op('query_student_archives_grow_up')) {
      this.activeTab = '7';
    } else if (app.permission.op('query_student_evaluation_stage_test')) {
      this.activeTab = '8';
    }
    if (this.$vxRoute.query && this.$vxRoute.query.formPage === 'intentionStudent') {
      this.activeTab = '5';
    }
    if (this.$vxRoute.query && this.$vxRoute.query.tab) {
      this.activeTab = this.$vxRoute.query.tab;
    }

    this.getStudent();
    this.monitorRefresh();

    // 【没有查看学员点名记录的权限时，每次进入学员详情界面都提示没有访问权限。】https://www.tapd.cn/65277844/bugtrace/bugs/view?bug_id=1165277844001026879
    if (app.permission.op('find_student_roll_call')) {
      this.curriculumListByRollCall();
    }

    this.$onBus('studentInputSuccess', this.getStudent);
    this.$onBus('studentDeatilRefresh', this.getStudent);
  },
  watch: {
    activeTab: {
      immediate: true,
      handler: function (nv, ov) {
        if (nv != ov) {
          this.getData();
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.yunxiao.student-details {
  display: flex;
  flex-direction: column;
  background-color: var(--g2);
  overflow: hidden;
  .main-nav {
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: hidden;
    #kechengTag {
      margin: 10px 0;
      ::v-deep.van-tabs__wrap {
        height: auto;
      }
      ::v-deep.van-tabs__nav {
        background-color: transparent;
        border:none;
        padding-left: 0;
      }
      ::v-deep .course-tag {
        min-width: auto;
        padding: 0 12px;
        // margin:0 6px;
        margin-right: 12px;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size:var(--fs-md) !important;
        line-height:var(--lh-md) !important;
        font-weight: 400 !important;
        background: var(--c1);
        color: var(--g7);
        background: var(--white);
      }
    }


    ::v-deep.van-tabs {
      // height: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      .van-tabs__content {
        // height: 100%;
        flex: 1;
        overflow: hidden;
        position: relative;
        .van-tab__pane {
          position: absolute;
          width: 100%;
          height: 100%;
          // overflow: auto;
          display: flex;
          flex-direction: column;
          .vxlist {
            // height: 100%;
            flex: 1;
            overflow-y: auto;
          }
        }
      }
    }
    ::v-deep.van-tabs__nav {
      background-color: transparent;
    }
    ::v-deep.van-tabs__wrap {
      width: 100%;
      height: calc(var(--w) * 46);
      background-color: transparent;
      .van-tab {
        min-width: calc(var(--w) * 88);
        flex: unset;
        white-space: nowrap;
        .van-tab__text {
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
        }
      }
    }
      
    .more-detail-infos {
      padding: calc(var(--gap) * 7) calc(var(--gap) * 16);
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      display: flex;
      box-sizing: border-box;
      align-items: center;
      justify-content: space-between;
      color: var(--g6);
      background-color: var(--g2);
      .total-hour-cost {
        color: var(--c4);
      }
    }
    .check-box {
      display: flex;
      justify-content: flex-end;
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
    }
  }
  &.fix-tabs .main-nav {
    ::v-deep.van-tabs__wrap {
      background-color: var(--white);
    }
  }
  .call-the-roll {
    margin: 0 calc(var(--gap) * 16);
    border-radius: var(--radius-sm);
    background-color: var(--white);
  }
}
</style>
<style lang="scss">
.yunxiao.student-details {
  &.fix-tabs {
    .van-tabs {
      padding-top: calc(var(--gap) * 44);
      .van-tabs__wrap {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;
      }
    }
  }
  .check-box {
    .van-checkbox__label {
      font-size:var(--fs-sm);
      line-height:var(--lh-sm);
      color: var(--g6);
    }
  }
}
.student-delete-dialog .van-dialog__message {
  text-indent: 2em;
}
</style>
